const DASHBOARD_GROUPS = ['web-page', 'web-page-without-create-project', 'super-admin'];
const TECHNICAL_GROUPS = ['heat-profile', 'coating-record-db', 'dcal-generator'];
/** Groups that set legacy `is-web-page` / sidebar flag (dashboard-capable or admin UI). */
const WEB_PAGE_STORAGE_GROUPS = [...DASHBOARD_GROUPS, 'admin'];

/**
 * Cognito may return `cognito:groups` as a string when the user has a single group.
 * @param {string[]|string|undefined|null} raw
 * @returns {string[]}
 */
export const normalizeCognitoGroups = (raw) => {
  if (raw == null || raw === '') return [];
  return Array.isArray(raw) ? raw : [raw];
};

export const hasWebDashboardAccess = (groups) => {
  const g = normalizeCognitoGroups(groups);
  return DASHBOARD_GROUPS.some((key) => g.includes(key));
};

export const hasWebPageStorageFlag = (groups) => {
  const g = normalizeCognitoGroups(groups);
  return WEB_PAGE_STORAGE_GROUPS.some((key) => g.includes(key));
};

/**
 * Default route after login (matches sidebar priority: dashboard, admin, technical, analysis).
 * @param {string[]|string|undefined|null} rawGroups
 * @returns {string}
 */
export const getDefaultPostLoginPath = (rawGroups) => {
  const groups = normalizeCognitoGroups(rawGroups);
  if (groups.length === 0) return '/web-page';
  if (hasWebDashboardAccess(groups)) return '/dashboard';
  if (groups.includes('admin')) return '/admin';
  if (groups.some((group) => TECHNICAL_GROUPS.includes(group))) return '/technical';
  if (groups.includes('analysis')) return '/log-report';
  return '/web-page';
};

/**
 * Determines the selected key based on user group permissions
 * @param {Array} userGroup - Array of user group names
 * @returns {string} The selected key based on user group
 */
export const getSelectedKeyFromUserGroup = (userGroup) => {
  const groups = normalizeCognitoGroups(userGroup);
  if (groups.length === 0) return '3';

  if (hasWebDashboardAccess(groups)) {
    return '1';
  }

  if (groups.includes('admin')) {
    return '4';
  }

  if (groups.some((group) => TECHNICAL_GROUPS.includes(group))) {
    return '5';
  }

  if (groups.includes('analysis')) {
    return '2';
  }

  return '3';
};
